module.exports = __webpack_public_path__ + "img/image7.1bf19a55.png";